import ChevronDownSVG from "@design-system/ui-icons/vanilla/ChevronDown"
import { createIcon } from "../createIcon"

export const ChevronDownIcon = createIcon(ChevronDownSVG)
